import React from "react";
import { Redirect, Route } from "react-router-dom";

function ProtectedRoute({ component: Component, ...rest }) {
  var login = sessionStorage.getItem("youji_token");
  return (
    
      <Route
        {...rest}
        render={(props) => {
          if (login) {
            return <Component {...props} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: "/signin",
                  state: { from: props.location },
                }}
              />
            );
          }
        }}
      />
    
  );
}

export default ProtectedRoute;
